'use client';

import { Shield, Lock, CreditCard, CheckCircle } from 'lucide-react';

interface TrustBadgeProps {
  type: 'ssl' | 'stripe' | 'secure' | 'verified';
  text?: string;
  className?: string;
  showIcon?: boolean;
}

export default function TrustBadge({ type, text, className = '', showIcon = true }: TrustBadgeProps) {
  const badges = {
    ssl: {
      icon: Lock,
      defaultText: 'SSL Secured',
      color: 'text-green-500'
    },
    stripe: {
      icon: CreditCard,
      defaultText: 'Secure Payments by Stripe',
      color: 'text-primary'
    },
    secure: {
      icon: Shield,
      defaultText: '100% Secure',
      color: 'text-primary'
    },
    verified: {
      icon: CheckCircle,
      defaultText: 'Verified',
      color: 'text-green-500'
    }
  };

  const badge = badges[type];
  const Icon = badge.icon;
  const displayText = text || badge.defaultText;

  return (
    <div className={`inline-flex items-center gap-1.5 ${className}`}>
      {showIcon && <Icon className={`h-4 w-4 ${badge.color}`} />}
      <span className="text-xs text-white/70">{displayText}</span>
    </div>
  );
}